export default __webpack_public_path__ + "static/media/sort_down.66299e1a.svg";